<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-ticket mr-2" />Pembuatan Tiket Baru</h5>
            <hr />
            <b-row>
                <b-col md="5">
                    <b-form-group label="Engine" label-for="i0">
                        <multiselect v-model="input.engine" id="i0"
                            :options="optEngines"
                            :allow-empty="false"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Engine"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="5">
                    <b-form-group label="Dibuat oleh" label-for="i1">
                        <b-form-input id="i1" v-model="input.dibuatOleh" required placeholder="Pembuat / Pelapor Kejadian" maxlength="255" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="5">
                    <b-form-group label="Keluhan" class="mb-0" label-for="i2">
                        <b-form-textarea
                            v-model="input.keluhan"
                            placeholder="Tulis keluhan..."
                            rows="8"
                            max-rows="8"
                            maxlength="500"
                        />
                    </b-form-group>
                    <div class="text-right small text-muted mb-3">{{ input.keluhan.length }} / 500</div>
                </b-col>
            </b-row>
            <b-button variant="primary" @click="$bvModal.show('modal-confirm')">
                <i class="fa fa-save mr-2" />Buat Tiket & Simpan
            </b-button>
        </b-card>
        <b-modal id="modal-confirm" title="Konfirmasi" centered no-close-on-esc no-close-on-backdrop>
            Buat dan simpan tiket ini?
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()" :disabled="isSubmitting">
                    Batal
                </b-button>
                <b-button variant="primary" @click="submitTiket" :disabled="isSubmitting">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'tiket-create',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,

            input: {
                engine: null,
                dibuatOleh: "",
                keluhan: ""
            },

            optEngines: []

        }
    },
    methods: {

        init() {

            this.initStatus = 0

            this.$axios.get("engine/selection").then(res => {
                this.initStatus = 1
                this.optEngines = res.data
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        submitTiket() {

            let payload = new FormData()
            payload.append("engineId", this.input.engine.id)
            payload.append("dibuatOleh", this.input.dibuatOleh)
            payload.append("keluhan", this.input.keluhan)

            this.isSubmitting = true
            this.$axios.post("tiket/new", payload).then(res => {

                this.$helper.setFlash(`Tiket No. ${res.data.name} berhasil dibuat dan disimpan!`)
                this.$router.push("/tiket")

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        }

    },
    created() {
        this.init()
    }
}
</script>
